module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/leromain.9dca7dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/leromain.jpg
// module id = cDdk
// module chunks = 0